import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {sendAjaxRequest} from 'helper/interceptors';

import {
  create,
  upload,
  createWorkOrderType,
  update,
  getById,
  search
} from './api';
import * as WorkOrderActionType from './constants';
import * as NotifyActionType from '../Notification/constants';
import { AppSettings } from '../constants';
import { ObjToParam } from '../helper/helper-api';

export function* createAsync(action) {

  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      //put({ type: WorkOrderActionType.SEARCH_WORK_ORDER_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Work order created' })
    ];
  } else {
    yield put({ type: WorkOrderActionType.ADD_EDIT_WORK_ORDER_TYPE_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* uploadAsync(action) {

  const result = yield call(upload, action.params.files);

  if (action.params.callBack) {action.params.callBack(result.data);}

}

export function* getByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: WorkOrderActionType.GET_REQUEST_WORK_TYPE_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createWorkTypeAsync(action) {

  const result = yield call(createWorkOrderType, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Work order type created' })
    ];
  } else {
    yield [
      put({ type: WorkOrderActionType.ADD_EDIT_REQUEST_WORK_TYPE_ERROR, data: { error: result.data, params: action.params.data } })
      // put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data && result.data.error ? result.data.error : '' })
    ];
  }
}

export function* updateAsync(action) {

  const result = yield call(update, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield [
      put({ type: WorkOrderActionType.ADD_EDIT_REQUEST_WORK_TYPE_ERROR, data: { error: result.data, params: action.params.data } })
      // put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data && result.data.error ? result.data.error : '' })
    ];
  }
}

export function* makeActiveAsync(action) {

  const result = yield call(sendAjaxRequest, AppSettings.GLOBAL_API_URL, `/apiv1/itemrepairs/${action.params.data}/active`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeInActiveAsync(action) {

  const result = yield call(sendAjaxRequest, AppSettings.GLOBAL_API_URL, `/apiv1/itemrepairs/${action.params.data}/inactive`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* selectListWOTAsync(action) {

  const result = yield call(sendAjaxRequest, AppSettings.CURRENT_SITE_URI, `/api/workorder-types/select-list-items?${ObjToParam(action.params)}`, {}, 'GET', false);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: WorkOrderActionType.SELECT_LIST_WOT_SUCCESS,
      data: result.data
    });
    if (action.callback) {action.callback(result.data);}
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchWorkOrder() {
  yield all([
    takeEvery(WorkOrderActionType.CREATE_WORK_ORDER_TYPE_ASYNC, createAsync),
    takeEvery(WorkOrderActionType.UPLOAD_WORK_ORDER_TYPE_ASYNC, uploadAsync),
    takeLatest(WorkOrderActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC, searchAsync),
    takeLatest(WorkOrderActionType.GET_REQUEST_WORK_TYPE_BY_ID_ASYNC, getByIdAsync),
    takeEvery(WorkOrderActionType.CREATE_REQUEST_WORK_TYPE_ASYNC, createWorkTypeAsync),
    takeEvery(WorkOrderActionType.UPDATE_REQUEST_WORK_TYPE_ASYNC, updateAsync),
    takeEvery(WorkOrderActionType.MAKE_ACTIVE_WORK_TYPE_ASYNC, makeActiveAsync),
    takeEvery(WorkOrderActionType.MAKE_INACTIVE_WORK_TYPE_ASYNC, makeInActiveAsync),
    takeLatest(WorkOrderActionType.SELECT_LIST_WOT_ASYNC, selectListWOTAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Work-Order-Type/saga.js